import type { DefaultTheme } from 'styled-components';

export const theme: DefaultTheme = {
  fontFamily: "'Inter', serif",
  media: {
    mobile: '@media (max-width: 768px)',
    tablet: '@media (max-width: 1023px)',
  },
  palette: {
    common: {
      black: '#3D3D3D',
      white: '#FFFFFF',
    },
    primary: {
      bold: '#F79443',
      light: '#FFBA81',
      gray: '#B2B2B2',
    },
    secondary: {
      gray: '#CFCFCF',
    },
    surface: {
      primary: '#FCFCFC',
      secondary: 'rgba(207, 207, 207, 0.2)',
    },
    error: '#AD0A0A',
    errorAccent: '#FFB8C1',
    success: '#D0FFD2',
  },
  utils: {
    pxToRem: (px: number) => `${px / 16}rem`,
  },
};
